import { DataTable } from 'components/base/DataTable';
import { Column } from 'primereact/column';
import { DataTableRowClickEventParams } from 'primereact/datatable';
import { useNavigate } from 'react-router-dom';
import { EXPORT_EVENTS_ROUTE } from 'routes/paths';

const exportSections = [
  // {
  //   name: 'Пациенты',
  //   route: EXPORT_PATIENTS_ROUTE,
  // },
  {
    name: 'События',
    route: EXPORT_EVENTS_ROUTE,
  },
];

const ExportRootPage = () => {
  const navigation = useNavigate();

  const handleClickRow = (rowData: DataTableRowClickEventParams) => {
    navigation(`${rowData.data.route}`);
  };

  return (
    <>
      <h1 className="mb-5">Выгрузка</h1>
      <DataTable
        value={exportSections}
        responsiveLayout="stack"
        onRowClick={handleClickRow}
      >
        <Column
          field="name"
          header="Название раздела"
        />
      </DataTable>
    </>
  );
};

export default ExportRootPage;
